












import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import PrintPuzzleGrid from '@/components/print/PrintPuzzleGrid.vue';
import PrintWordList from '@/components/print/PrintWordList.vue';
import { getMonthName } from '@/utils/date-helpers';

const puzzle = namespace('Puzzle');

@Component({
  components: {
    PrintPuzzleGrid,
    PrintWordList,
  },
})
export default class PrintPage extends Vue {
  @puzzle.State
  private date!: string;

  get formatedDate() {
    const date = new Date(this.date);
    return `${getMonthName(date.getMonth())} ${date.getDate()}, ${date.getFullYear()}`;
  }
}
